(() => {
  'use strict';

  const STATE_SELECTOR = '[data-restricted-cart-state]';
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.cart__checkout-button',
    '#checkout',
    '#CartDrawer-Checkout',
    '[data-checkout-button]'
  ].join(',');

  const CHECKOUT_LINK_SELECTOR = 'a[href="/checkout"], a[href*="/checkout"]';

  const ACCELERATED_SELECTOR = [
    '.additional-checkout-buttons',
    '.cart__dynamic-checkout-buttons',
    '.dynamic-checkout__content',
    '[data-shopify-buttoncontainer]',
    'shopify-accelerated-checkout'
  ].join(',');

  let scheduled = false;

  function isInvalidCart() {
    return Array.from(document.querySelectorAll(STATE_SELECTOR)).some(
      (element) => element.dataset.invalid === 'true'
    );
  }

  function disableCheckoutButton(button) {
    if (!button.dataset.restrictedOriginalText) {
      button.dataset.restrictedOriginalText =
        button.tagName === 'INPUT'
          ? button.value
          : button.textContent.trim();
    }

    button.disabled = true;
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-disabled', 'true');
    button.dataset.restrictedCheckoutDisabled = 'true';
    button.classList.add('restricted-checkout-disabled');
  }

  function enableCheckoutButton(button) {
    if (button.dataset.restrictedCheckoutDisabled !== 'true') return;

    button.disabled = false;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.classList.remove('restricted-checkout-disabled');
    delete button.dataset.restrictedCheckoutDisabled;

    const originalText = button.dataset.restrictedOriginalText;
    if (originalText) {
      if (button.tagName === 'INPUT') {
        button.value = originalText;
      } else {
        button.textContent = originalText;
      }
    }
  }

  function disableCheckoutLink(link) {
    if (!link.dataset.restrictedOriginalHref) {
      link.dataset.restrictedOriginalHref = link.getAttribute('href') || '/checkout';
    }

    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('tabindex', '-1');
    link.dataset.restrictedCheckoutDisabled = 'true';
    link.classList.add('restricted-checkout-disabled');
  }

  function enableCheckoutLink(link) {
    if (link.dataset.restrictedCheckoutDisabled !== 'true') return;

    link.setAttribute('href', link.dataset.restrictedOriginalHref || '/checkout');
    link.removeAttribute('aria-disabled');
    link.removeAttribute('tabindex');
    link.classList.remove('restricted-checkout-disabled');
    delete link.dataset.restrictedCheckoutDisabled;
  }

  function hideAcceleratedCheckout(container) {
    if (!container.dataset.restrictedOriginalDisplay) {
      container.dataset.restrictedOriginalDisplay = container.style.display || '';
    }

    container.style.display = 'none';
    container.setAttribute('aria-hidden', 'true');
    container.dataset.restrictedCheckoutHidden = 'true';
  }

  function showAcceleratedCheckout(container) {
    if (container.dataset.restrictedCheckoutHidden !== 'true') return;

    container.style.display = container.dataset.restrictedOriginalDisplay || '';
    container.removeAttribute('aria-hidden');
    delete container.dataset.restrictedCheckoutHidden;
  }

  function updateCheckoutState() {
    const invalid = isInvalidCart();

    document.querySelectorAll(CHECKOUT_SELECTOR).forEach((button) => {
      invalid ? disableCheckoutButton(button) : enableCheckoutButton(button);
    });

    document.querySelectorAll(CHECKOUT_LINK_SELECTOR).forEach((link) => {
      invalid ? disableCheckoutLink(link) : enableCheckoutLink(link);
    });

    document.querySelectorAll(ACCELERATED_SELECTOR).forEach((container) => {
      invalid ? hideAcceleratedCheckout(container) : showAcceleratedCheckout(container);
    });

    document.documentElement.classList.toggle('restricted-cart-is-invalid', invalid);
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      updateCheckoutState();
    });
  }

  document.addEventListener('DOMContentLoaded', updateCheckoutState);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('cart:refresh', scheduleUpdate);
  document.addEventListener('cart-drawer:open', scheduleUpdate);

  document.addEventListener(
    'submit',
    (event) => {
      if (!isInvalidCart()) return;

      const submitter = event.submitter;
      if (!submitter) return;

      if (
        submitter.name === 'checkout' ||
        submitter.matches('.cart__checkout-button, #checkout, #CartDrawer-Checkout')
      ) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  updateCheckoutState();
})();
